var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, createData } from "../dataAccess";
//============================================================================================================
//                                          ADMIN DATA SYNC
//============================================================================================================
// List every table this environment can sync (used to build the checklist)
export const getSyncTables = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sync/tables`;
    return getData(url);
});
// Pull data from a source environment's API into this one
export const pullSync = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sync/pull`;
    return createData(url, request);
});
// List every stored procedure/function this environment can sync (used to build the checklist)
export const getSyncRoutines = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sync/routines`;
    return getData(url);
});
// Pull stored procedure/function definitions from a source environment's API into this one
export const pullSyncRoutines = (request) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `Sync/pull-routines`;
    return createData(url, request);
});
